import React, { useEffect, useContext, useState } from 'react';
import '../../css/ManagePlan.css';
import { Link } from 'react-router-dom';
import managePlane from '../../images/managePlane.jpg';
import wired from '../../images/wired-outline.gif';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import ConfirmationModal from '../modals/ConfirmationModal';
import config from '../../config/config';

const ManagePlan = () => {

    const { user, isAuthenticated } = useContext(AppContext);
    const [showModal, setShowModal] = useState(false);
        const [msgTitle, setMsgTitle] = useState("");
        const [message, setMessage] = useState("");
        const [icon, setIcon] = useState("");
        const [theme, setTheme] = useState("");


    const [transactionData, setTransactionData] = useState([]);
    // Fetch Bearer token (Assuming it's stored in localStorage)
    // const token = localStorage.getItem('authToken');
      const token = config.getAuthToken();

    const fetchTransactionData = async () => {
        try {

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/getMyTransactions`,
                { userId: user?.data?.id },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status) {
                setTransactionData(response.data.data); // Assuming 'data' contains the reviews array
                //alert(JSON.stringify(response.data.data));

            }
        } catch (error) {
            console.error('Error fetching reviews:', error);
            if (error.response) {
                if (error.response.status === 404) {
                  setShowModal(true)
                  setMsgTitle('No plan found for this user')
                  setMessage()
                  setIcon('fa fa-info-circle')
                  setTheme('gold')
                } else {
                  setShowModal(true)
                  setMsgTitle('Failed to fetch data. Please try again.')
                  setMessage()
                  setIcon('fa fa-times-circle-o')
                  setTheme('red')
                }
              } else {
                // error.response is undefined - network error, timeout, CORS, etc
                setShowModal(true)
                setMsgTitle('Something went wrong. Please check your connection.')
                setMessage()
                setIcon('fa fa-times-circle-o')
                setTheme('red')
              }
        }
    };



    useEffect(() => {
        if (isAuthenticated) {
            fetchTransactionData();
            //alert( user?.data?.id);
        }
    }, [isAuthenticated]);

    return (
        <>
            <div>
                <div className='d-flex justify-content-between planbox'>
                    <div className='title-header-filter breadcrumb'>
                        <div className='profile-path'>
                            <span>Manage My Plan</span>
                        </div>
                    </div>
                    <div className=" border-bottom-0">
                        <Link to="/packagePage" className='text-decoration none btn profile-edit' style={{ minWidth: '167px' }}>

                            <svg width="13" height="13" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 0L0 4V6.5L6 2.68457L12 6.5V4L6 0ZM6 5L2 7.5V9.5L6 7L10 9.5V7.5L6 5ZM6 9.02344L4 10.6094V12L6 10.6094L8 12V10.6094L6 9.02344Z" fill="white" />
                            </svg>

                            Upgrade My Plan

                        </Link>
                    </div>
                </div>

                <div className='manage-main-area pt-4 pb-4'>

                    <div className='plandtlbx d-flex justify-content-between' style={{ width: '100%' }}>

                        <div style={{ width: '100%' }}>
                            <p className='plan-detail-info'>Your membership plan details:</p>
                            {/* {transactionData.length > 0 ? (
                            transactionData.map((transactionData, index) => ( */}
                            <div style={{ lineHeight: '20px' }}>
                                <div className='plan-description'>
                                    <p className='plan-description-key'>Account No.</p>
                                    <p className='plan-description-value'>{transactionData.transaction_id ?? 'D-908045'}</p>
                                </div>
                                <div className='plan-description'>
                                    <p className='plan-description-key'>Current Plan</p>
                                    <p className='plan-description-value'>{transactionData.package_name ?? 'Platinum'}</p>
                                </div>
                                <div className='plan-description'>
                                    <p className='plan-description-key'>Price paid</p>
                                    <p className='plan-description-value'>₹{transactionData.price ?? '6500'}/- <span className='gst-value'>( +18% GST )</span></p>
                                </div>
                                <div className='plan-description'>
                                    <p className='plan-description-key'>Validity</p>
                                    <p className='plan-description-value'>{transactionData.validity_days ?? '45'} Days</p>
                                </div>
                                <div className='plan-description'>
                                    <p className='plan-description-key'>Valid Upto</p>
                                    <p className='plan-description-value'>{new Date(transactionData.expired_on).toLocaleDateString()}
                                    </p>
                                </div>
                            </div>
                            {/* ))
                        ) : (
                            <p>No reviews found.</p>
                        )} */}

                        </div>
                        <div className="position-relative d-inline-block pt-2">
                            <img src={managePlane} className="managePlanebox img-fluid mt-0" alt="..." />
                            <img src={wired} className="wired-img position-absolute top-50  translate-middle" alt="..." style={{ marginTop: '-135px', left: '3%' }} />
                        </div>
                    </div>



                    <div className='plandtlbx d-flex justify-content-between mt-5' style={{ width: '100%' }}>

                        <div className='bnftbx'>
                            <p className='benefit-para'>Benefits:</p>
                            {/* {transactionData.length > 0 ? (
                                transactionData.map((transactionData, index) => ( */}
                            <div>
                                <div className='benefit-detail'>
                                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="3" cy="3" r="3" fill="#343434" />
                                    </svg>
                                    <span>Zero Brokerage owners contacts</span>
                                    <div className='dotted-border'></div>
                                    <div>{transactionData.matching_buyers || '-'}</div>
                                </div>
                                <div className='benefit-detail'>
                                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="3" cy="3" r="3" fill="#343434" />
                                    </svg>
                                    <span>Priority Customer support</span>
                                    <div className='dotted-border'></div>
                                    <div>{transactionData.relationship_manager ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.03979 16.6399L13.0136 22.3999L24.9598 10.8799" stroke="#343434" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> : '✗'}
                                    </div>
                                </div>
                                <div className='benefit-detail'>
                                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="3" cy="3" r="3" fill="#343434" />
                                    </svg>
                                    <span>Instant alerts on new properties</span>
                                    <div className='dotted-border'></div>
                                    <div>{transactionData.field_visit_assistance ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.03979 16.6399L13.0136 22.3999L24.9598 10.8799" stroke="#343434" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> : '✗'}
                                    </div>
                                </div>
                                <div className='benefit-detail'>
                                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="3" cy="3" r="3" fill="#343434" />
                                    </svg>
                                    <span>Dedicated relationship manager</span>
                                    <div className='dotted-border'></div>
                                    <div>{transactionData.photoshoot_assistance ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.03979 16.6399L13.0136 22.3999L24.9598 10.8799" stroke="#343434" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> : '✗'}
                                    </div>
                                </div>
                            </div>
                            {/* ))
                            ) : (
                                <p>No reviews found.</p>
                            )} */}
                        </div>
                        <div className='tncbx'>
                            <p className='term-condition-para'>Term & Conditions:</p>

                            <div className=' term-condition-detail'>
                                <span className="arrow">{'>'}</span> <p className='with-arrow'>Benefits such as "Zero Brokerage Owner Contacts," "Priority Customer Support," and "Instant Alerts on New Properties" are plan-specific.</p>
                            </div>
                            <div className=' term-condition-detail'>

                                <span className="arrow">{'>'}</span> <p className='with-arrow'>The validity of the plan starts from the date of activation and ends on the mentioned expiration date.</p>
                            </div>
                            <div className=' term-condition-detail'>
                                <span className="arrow">{'>'}</span>  <p className='with-arrow'>The availability of these benefits is subject to the terms of the purchased plan and may vary depending on the plan type.</p>
                            </div>
                            <div className=' term-condition-detail'>


                                <span className="arrow">{'>'}</span>   <p className='with-arrow'>All prices are inclusive of applicable taxes such as GST (18%). Any change in tax rates may affect the final payable amount.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {showModal && (
          <ConfirmationModal
            onClose={() => setShowModal(false)}
            title={msgTitle}
            message={message}
            icon={icon}
            theme={theme}
          />
        )}

            {/* <div className=' mt-3'>
                        <p className='plan-detail-info'>Your membership plan details:</p>
                        {transactionData.length > 0 ? (
                            transactionData.map((transactionData, index) => (
                                <div>
                                    <div className='plan-description'>
                                        <p className='plan-description-key'>Account No.</p>
                                        <p className='plan-description-value'>{transactionData.transaction_id}</p>
                                    </div>
                                    <div className='plan-description'>
                                        <p className='plan-description-key'>Current Plan</p>
                                        <p className='plan-description-value'>{transactionData.package_name}</p>
                                    </div>
                                    <div className='plan-description'>
                                        <p className='plan-description-key'>Price paid</p>
                                        <p className='plan-description-value'>₹{transactionData.price}/- <span className='gst-value'>( +18% GST )</span></p>
                                    </div>
                                    <div className='plan-description'>
                                        <p className='plan-description-key'>Validity</p>
                                        <p className='plan-description-value'>{transactionData.validity_days} Days</p>
                                    </div>
                                    <div className='plan-description'>
                                        <p className='plan-description-key'>Valid Upto</p>
                                        <p className='plan-description-value'>{new Date(transactionData.expired_on).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No reviews found.</p>
                        )}
                    </div>
                    <div className=''>

                        <img src={managePlane} class="card-img-top mt-0" alt="..." />
                        <img src={wired} class="card-img-top wired-img mt-0" alt="..." />
                    </div>

                    <div className=' mt-3'>
                        <div className=''>
                            <p className='benefit-para'>Benefits:</p>
                            {transactionData.length > 0 ? (
                                transactionData.map((transactionData, index) => (
                                    <div>
                                        <div className='benefit-detail'>
                                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="3" cy="3" r="3" fill="#343434" />
                                            </svg>
                                            <span>Zero Brokerage owners contacts</span>
                                            <div className='dotted-border'></div>
                                            <div>{transactionData.matching_buyers || '-'}</div>
                                        </div>
                                        <div className='benefit-detail'>
                                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="3" cy="3" r="3" fill="#343434" />
                                            </svg>
                                            <span>Priority Customer support</span>
                                            <div className='dotted-border'></div>
                                            <div>{transactionData.relationship_manager ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.03979 16.6399L13.0136 22.3999L24.9598 10.8799" stroke="#343434" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg> : '✗'}
                                            </div>
                                        </div>
                                        <div className='benefit-detail'>
                                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="3" cy="3" r="3" fill="#343434" />
                                            </svg>
                                            <span>Instant alerts on new properties</span>
                                            <div className='dotted-border'></div>
                                            <div>{transactionData.field_visit_assistance ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.03979 16.6399L13.0136 22.3999L24.9598 10.8799" stroke="#343434" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg> : '✗'}
                                            </div>
                                        </div>
                                        <div className='benefit-detail'>
                                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="3" cy="3" r="3" fill="#343434" />
                                            </svg>
                                            <span>Dedicated relationship manager</span>
                                            <div className='dotted-border'></div>
                                            <div>{transactionData.photoshoot_assistance ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.03979 16.6399L13.0136 22.3999L24.9598 10.8799" stroke="#343434" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg> : '✗'}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No reviews found.</p>
                            )}
                        </div>
                        <div className=''>
                            <p className='term-condition-para'>Term & Conditions:</p>
                            <div style={{ width: "110%" }}>
                            <div className='term-condition-detail'>
                                    <svg width="17" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.66466 10.6714C5.89246 10.8992 6.26183 10.8992 6.48962 10.6714L9.3406 7.81759C9.79584 7.36194 9.79566 6.62356 9.34025 6.16809L6.48752 3.31538C6.25973 3.08758 5.89036 3.08758 5.66256 3.31538C5.43475 3.54319 5.43475 3.91254 5.66256 4.14035L8.10417 6.58197C8.33202 6.80976 8.33202 7.17913 8.10417 7.40692L5.66466 9.84648C5.43685 10.0743 5.43685 10.4436 5.66466 10.6714Z" fill="#343434" />
                                    </svg>
                                    <p className='mb-0'>Benefits such as "Zero Brokerage Owner Contacts," "Priority Customer Support," and "Instant Alerts on New Properties" are plan-specific.</p>
                                </div>
                                <div className='term-condition-detail'>
                                    <svg width="17" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.66466 10.6714C5.89246 10.8992 6.26183 10.8992 6.48962 10.6714L9.3406 7.81759C9.79584 7.36194 9.79566 6.62356 9.34025 6.16809L6.48752 3.31538C6.25973 3.08758 5.89036 3.08758 5.66256 3.31538C5.43475 3.54319 5.43475 3.91254 5.66256 4.14035L8.10417 6.58197C8.33202 6.80976 8.33202 7.17913 8.10417 7.40692L5.66466 9.84648C5.43685 10.0743 5.43685 10.4436 5.66466 10.6714Z" fill="#343434" />
                                    </svg>
                                    <p className='mb-0'>The validity of the plan starts from the date of activation and ends on the mentioned expiration date.</p>
                                </div>
                                <div className='term-condition-detail'>
                                    <svg width="17" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.66466 10.6714C5.89246 10.8992 6.26183 10.8992 6.48962 10.6714L9.3406 7.81759C9.79584 7.36194 9.79566 6.62356 9.34025 6.16809L6.48752 3.31538C6.25973 3.08758 5.89036 3.08758 5.66256 3.31538C5.43475 3.54319 5.43475 3.91254 5.66256 4.14035L8.10417 6.58197C8.33202 6.80976 8.33202 7.17913 8.10417 7.40692L5.66466 9.84648C5.43685 10.0743 5.43685 10.4436 5.66466 10.6714Z" fill="#343434" />
                                    </svg>
                                    <p className='mb-0'>The availability of these benefits is subject to the terms of the purchased plan and may vary depending on the plan type.</p>
                                </div>
                              
                                <div className='term-condition-detail'>
                                    <svg width="17" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.66466 10.6714C5.89246 10.8992 6.26183 10.8992 6.48962 10.6714L9.3406 7.81759C9.79584 7.36194 9.79566 6.62356 9.34025 6.16809L6.48752 3.31538C6.25973 3.08758 5.89036 3.08758 5.66256 3.31538C5.43475 3.54319 5.43475 3.91254 5.66256 4.14035L8.10417 6.58197C8.33202 6.80976 8.33202 7.17913 8.10417 7.40692L5.66466 9.84648C5.43685 10.0743 5.43685 10.4436 5.66466 10.6714Z" fill="#343434" />
                                    </svg>
                                    <p className='mb-0'>All prices are inclusive of applicable taxes such as GST (18%). Any change in tax rates may affect the final payable amount.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}


        </>



    )
}

export default ManagePlan
